export const channel = new BroadcastChannel("app_channel");

/**
 * Invia messaggi attraverso il BroadcastChannel
 * @param {string} type - Tipo di messaggio (reload_now, lazy_reload)
 * @param {any} data - Dati aggiuntivi (facoltativo)
 */
export const sendMessageToOtherTabs = (type, data = null) => {
    channel.postMessage({ type, data });
};